export const runAsync = (operation: Promise<unknown>): void => {
  operation.catch((error: unknown): void => {
    console.error("Unexpected asynchronous UI error:", error);
  });
};
